import React from 'react';

const CircularProgress = () => (
  <div>
    <img src="/loader.svg" alt="loader" />
  </div>
);
export default CircularProgress;
